import { Component, Input, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Role } from 'src/app/core/models/role';
import { AuthService } from 'src/app/core/services/auth.service';
import { CompanyService } from 'src/app/core/services/company.service';
import { FilialService } from 'src/app/core/services/filial.service';
import { BreadcrumbService } from 'xng-breadcrumb';

@Component({
  selector: 'app-new-filial',
  templateUrl: './new-filial.component.html',
  styleUrls: ['./new-filial.component.css'],
})
export class NewFilialComponent implements OnInit {
  filial: any = {};
  isLoading = false;
  companyId: string;
  filialId: string;
  currentUser: any;
  isLoadingForm = false;

  @Input() isAllFilials:boolean;

  constructor(
    private location: Location,
    private filialService: FilialService,
    private toastr: ToastrService,
    private router: Router,
    private route: ActivatedRoute,
    private authService: AuthService,
    private breadcrumbService: BreadcrumbService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });

    if (this.currentUser.role.name === Role.USER) {
      this.companyId = this.currentUser.companyId;
    } else {
      this.route.parent.parent.data.subscribe((res) => {
        this.companyId = res.company.id;
        this.breadcrumbService.set('@companyName', res.company.name);
      });
    }

    if (this.router.url.includes('new-filial')) {
      this.filial.isNew = true;
      this.isLoading = false;
    } else {
      this.filialId = this.route.snapshot.params.filialId;
      this.loadFilial();
    }
  }

  /**
   * Load selected filial
   */
  loadFilial() {
    this.filialService.getFilialById(this.companyId, this.filialId).subscribe(
      (res) => {
        this.filial = res;
        this.filial.isNew = false;
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
      }
    );
  }

  addFilial(form: NgForm) {
    let body = {};

    if (!form.valid) {
      this.translate.get('global.requiredFields').subscribe((res: string) => {
        this.toastr.error(res);
      });
      return false;
    }

    Object.entries(form.form.value).forEach(([key, value], index) => {
      if (value) {
        body[key] = value;
      }
    });

    this.isLoadingForm = true;

    this.filialService.createFilial(this.companyId, body).subscribe(
      (res) => {
        this.translate
          .get('filials.filial.filialCreated', { name: res.name })
          .subscribe((res: string) => {
            this.toastr.success(res);
          });
        this.filial = {};
        this.filial.isNew = true;
        this.isLoadingForm = false;

        this.router.navigate(['..'], { relativeTo: this.route });
      },
      (err) => {
        this.isLoadingForm = false;
        this.toastr.error(err.error.description);
      }
    );
  }

  editFilial(form: NgForm) {
    if (!form.valid) {
      this.translate.get('global.requiredFields').subscribe((res: string) => {
        this.toastr.error(res);
      });
      return;
    }

    const editData = form.form.value;

    const body = {};

    Object.keys(this.filial).forEach((key) => {
      if (key in editData) {
        if (this.filial[key] !== editData[key]) {
          body[key] = editData[key] === '' ? null : editData[key];
        }
      }
    });

    if (Object.keys(body).length === 0 && body.constructor === Object) {
      return;
    }

    this.isLoadingForm = true;

    this.filialService
      .editFilial(this.companyId, this.filialId, body)
      .subscribe(
        (res) => {
          this.translate
            .get('filials.filial.filialEdited')
            .subscribe((res: string) => {
              this.toastr.success(res);
            });
          this.isLoadingForm = false;
          this.location.back();
         // this.router.navigate(['../..'], { relativeTo: this.route });
        },
        (err) => {
          this.isLoadingForm = false;
        }
      );
  }
}
